import { Injectable } from '@angular/core';
import { BaseApi } from './_base-api';
import { GoogleFeedGenerationEntity, GoogleFeedSettingsEntity } from '@models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GoogleFeedApiService extends BaseApi<GoogleFeedSettingsEntity> {
  constructor() {
    super('/AdminPanel/GoogleFeed');
  }

  override get(): Observable<GoogleFeedSettingsEntity> {
    return http$.get<GoogleFeedSettingsEntity>('/AdminPanel/GetGoogleFeedSettings');
  }

  set(model: GoogleFeedSettingsEntity) {
    return http$.put('/AdminPanel/SetGoogleFeedSettings', {
      offersCategoryId: model.offersCategoryId,
    });
  }

  /** Builds the feed right away instead of waiting for the nightly job. */
  regenerate(): Observable<GoogleFeedGenerationEntity> {
    return http$.post<GoogleFeedGenerationEntity>('/AdminPanel/RegenerateGoogleFeed', {});
  }
}
